exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resource-details[data-v-bacbb47c]{margin-top:72px;padding-top:40px}.resource-details__video[data-v-bacbb47c]{margin-bottom:30px}", ""]);

// exports
